module.exports = __webpack_public_path__ + "static/media/visitbrussels_4.169e0002.jpg";